import Vue from 'vue';
import Vuex from 'vuex';

import {
  summery
}
from './summery.module';



Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    summery
  }
});
